import React from 'react';
// import styles from './LoadingScreen.module.css'; // If you have specific styles for it
import logoPath from '../assets/NOOR.png'; // Ensure this path is correct

interface LoadingScreenProps {
  progress?: number; 
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ progress }) => {
  return (
    <div className="fixed inset-0 bg-white flex flex-col items-center justify-center z-[100]">
      <div className="text-center">
        <img src={logoPath} alt="Loading..." className="mx-auto h-24 w-auto mb-6 animate-pulse" />
        <p className="text-xl font-semibold text-gray-700 mb-4">Loading Application...</p>
        
        {typeof progress === 'number' && (
          <div className="w-64 sm:w-80 bg-gray-200 rounded-full h-2.5 mb-2">
            <div
              className="bg-yellow-400 h-2.5 rounded-full transition-all duration-150 ease-linear"
              style={{ width: `${Math.max(0, Math.min(100, progress))}%` }} // Ensure width is between 0 and 100
            ></div>
          </div>
        )}
        {typeof progress === 'number' && (
          <p className="text-sm text-gray-600">{Math.round(Math.max(0, Math.min(100, progress)))}%</p>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen; 